import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ResizeIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 30">
      <g clipPath="url(#clip0_5_37)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H9.28575C10.2062 0 10.9524 0.746192 10.9524 1.66667C10.9524 2.58714 10.2062 3.33333 9.28575 3.33333H5.69036L26.6667 24.3096V20.7143C26.6667 19.7938 27.4129 19.0476 28.3333 19.0476C29.2538 19.0476 30 19.7938 30 20.7143V30H20.7143C19.7938 30 19.0476 29.2538 19.0476 28.3333C19.0476 27.4129 19.7938 26.6667 20.7143 26.6667H24.3096L3.33333 5.69036V9.28575C3.33333 10.2062 2.58714 10.9524 1.66667 10.9524C0.746192 10.9524 0 10.2062 0 9.28575V0Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_37">
          <rect width="30" height="30" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default ResizeIcon;
